import { render, staticRenderFns } from "./CoreanosForm.vue?vue&type=template&id=85497a9a&scoped=true"
import script from "./CoreanosForm.vue?vue&type=script&lang=js"
export * from "./CoreanosForm.vue?vue&type=script&lang=js"
import style0 from "./CoreanosForm.vue?vue&type=style&index=0&id=85497a9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85497a9a",
  null
  
)

export default component.exports